import { ResourceProps } from "@refinedev/core";
import { FaBook, FaCalendar, FaHouse, FaPerson } from "react-icons/fa6";

export const resources: ResourceProps[] = [
    {
        name: "home",
        list: "/home",
        meta: {
            label: "app.home",
            mainMenu: true,
            icon: <FaHouse />
        }
    },
    {
        name: "auth_users",
        list: "/users",
        show: "/users/show/:id",
        edit: '/users/edit/:id',
        meta: {
            label: "app.users"
        }
    },
    {
        name: "onboarding",
        list: "/onboarding",
        meta: {
            label: "app.onboarding"
        }
    },
    {
        name: "successful_payment",
        list: "/successful_payment",
        meta: {
            label: "app.sucessful_payment"
        }
    },
    {
        name: "calendar",
        list: "/calendar",
        create: "/calendar/new",
        meta: {
            label: "app.calendar",
            mainMenu: true,
            icon: <FaCalendar />
        }
    },
    {
        name: "appointment",
        create: "/appointments/new",
        // create: "/calendar/new",
        meta: {
            label: "app.appointment",
            // mainMenu: true,
            // icon: <FaCalendar />
        }
    },
    {
        name: 'content',
        list: '/content',
        show: '/content/:id',
        meta: {
            label: "app.content",
            mainMenu: true,
            icon: <FaBook />
        }
    },
    {
        name: "config",
        list: "/config",
        meta: {
            label: "app.config",
            mainMenu: true,
            icon: <FaPerson />
        }
    },
    {
        name: "pqrs",
        show: "/config/pqrs",
        meta: {
            label: "app.pqrs",
        }
    },
    {
        name: "helps",
        list: "/helps",
        meta: {
            label: "app.helps"
        }
    },
    {
        name: "contact-professional",
        list: "/contact-professional",
        meta: {
            label: "app.contact-professional"
        }
    },
    {
        name: 'test',
        show: '/test'
    }
]